/**
 * EliorGroup.Joyfood.B2B2C API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type InAppNotificationPriority = null | null | null | null;

export const InAppNotificationPriority = {
    NUMBER_null: null as InAppNotificationPriority,
    NUMBER_null2: null as InAppNotificationPriority,
    NUMBER_null3: null as InAppNotificationPriority,
    NUMBER_null4: null as InAppNotificationPriority
};

